<template>
  <div class="sub-com-wrap">
    <div class="title">
      <div class="sep"></div>
      待确认办税人员
    </div>

    <div class="content">
      <el-form :model="queryParams" class="add-form"
               ref="formRef" :rules="{}" :inline="true" label-width="70px">

        <el-form-item
            label="姓名"
            prop="ticName">
          <el-input
              v-model="queryParams.ticName"
              style="width: 200px;"
              clearable
              placeholder="请输入姓名"/>
        </el-form-item>

        <el-form-item
            label="身份类型"
            prop="roleType">
          <el-select
              v-model="queryParams.roleType"
              placeholder="请选择身份类型"
              clearable
              style="width: 200px;"
          >
            <el-option label="办税员" value="办税员"/>
            <el-option label="开票员" value="开票员"/>
            <el-option label="管理员" value="管理员"/>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="queryData">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table
          ref="tableRef"
          :data="showTableList"
          class="confirm-user-table"
          style="margin-top: 10px;"
          border
      >
        <el-table-column type="index" label="序号" fixed="left" align="center" width="60"/>

        <el-table-column label="姓名" align="center" prop="ticName" min-width="100"/>

        <el-table-column label="证件类型" align="center" prop="idType" min-width="120"/>

        <el-table-column label="证件号码" align="center" prop="idNumber" min-width="150"/>

        <el-table-column label="手机号码" align="center" prop="phone" min-width="120"/>

        <el-table-column label="身份类型" align="center" prop="roleType" min-width="100"/>

        <el-table-column label="发起时间" align="center" prop="createTime" min-width="120"/>

        <el-table-column
            fixed="right"
            label="操作" align="center"
            min-width="100">
          <template #default="{row, $index}">
            <el-button
                size="small"
                type="danger"
                @click="deleteRow($index)"
            >删除
            </el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script setup>
import {useTaxUserStore} from "./addTaxPina.js";

const store = useTaxUserStore()
const {userAnswer} = storeToRefs(store);
const queryParams = reactive({})

const showTableList = ref([{}])

onMounted(() => {
  queryData()
})

function queryData() {
  let resList = userAnswer.value.filter(f => f.isAuth != '是')
  if (queryParams.ticName) {
    resList = resList.filter(f => f.ticName.indexOf(queryParams.ticName) > -1)
  }
  if (queryParams.roleType) {
    resList = resList.filter(f => f.roleType == queryParams.roleType)
  }
  showTableList.value = resList
}

function deleteRow(index) {
  ElMessageBox.confirm("确认删除本条数据?", "提示")
      .then(() => {
        userAnswer.value.splice(index, 1)
        queryData()
      })
      .catch(() => {
      })
}
</script>

<style scoped lang="scss">
.sub-com-wrap {
  height: 100%;
  background-color: #FFFFFF;
  box-sizing: border-box;
  padding: 18px 20px;

  .title {
    font-size: 20px;
    line-height: 30px;
    color: #303133;
    font-weight: 700;
    display: flex;
    align-items: center;

    .sep {
      width: 5px;
      background-color: #409eff;
      margin-right: 8px;
      height: 20px;
      border-radius: 20%;
    }
  }

  .content {
    margin-top: 20px;

    :deep(.confirm-user-table) {
      .el-table__header {
        th.el-table__cell {
          background-color: #f9fafd;
        }
      }
    }
  }

}
</style>
